import { type MCPServerInfo } from '../../types';

const TimeServer: MCPServerInfo = {
  serverId: 'TIME',
  name: 'Time',
  slug: 'time',
  description: 'Time and timezone conversion capabilities.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'mcp/time:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['gpgKey', 'pythonVersion', 'pythonSha256'],
    properties: {
      gpgKey: {
        type: 'string',
        description: 'gpgKey',
        sensitive: true
      },
      pythonVersion: {
        type: 'string',
        description: 'pythonVersion',
        sensitive: false
      },
      pythonSha256: {
        type: 'string',
        description: 'pythonSha256',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default TimeServer;
